module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', _vm._l((_vm.authors), function(a) {
    return _c('div', {
      staticClass: "author"
    }, [_c('div', {
      staticClass: "ava",
      style: ({
        'background-image': _vm.url(a.ava)
      })
    }, [_c('img', {
      attrs: {
        "src": a.ava,
        "alt": ""
      }
    })]), _vm._v(" "), _c('span', {
      domProps: {
        "textContent": _vm._s(a.name)
      }
    })])
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-abed001a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/event/parts/authors.vue
// module id = 161
// module chunks = 1